import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/img.jpg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = { class: "header-user-con" }
const _hoisted_4 = { class: "el-dropdown-link" }
const _hoisted_5 = {
  key: 0,
  href: "https://github.com/lin-xin/vue-manage-system",
  target: "_blank"
}

import UpdatePwd from "@/components/UpdatePwd";
import router, {reloadRouter} from "@/router";
import {computed, ref} from "vue";
import store from "@/store";
import {Fold,Expand} from "@element-plus/icons-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const fullscreen = ref(false)
const message = ref(2);
const updatePwdRef = ref()
const collapse = computed(() => {
      return store.state.collapse;
    }
);

function handleCommand(command: string) {
  if (command === "loginOut") {
    store.commit("loginOut")
    reloadRouter();
    router.push("/login");
  } else if (command === "updatePwd") {
    updatePwdRef.value.show();
  }
}

function collapseChange() {
  store.commit("handleCollapse", !collapse.value);
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "collapse-btn",
      onClick: collapseChange
    }, [
      (!collapse.value)
        ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(Fold))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_unref(Expand))
            ]),
            _: 1
          }))
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "logo" }, "后台管理系统", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "user-avator" }, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1)),
        _createVNode(_component_el_dropdown, {
          class: "user-name",
          trigger: "click",
          onCommand: handleCommand
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                false
                  ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("项目仓库", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_dropdown_item, {
                  divided: "",
                  command: "updatePwd"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("修改密码", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  divided: "",
                  command: "loginOut"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("退出登录", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(store).state.user.name) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "el-icon-caret-bottom" }, null, -1))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(UpdatePwd), {
      ref_key: "updatePwdRef",
      ref: updatePwdRef
    }, null, 512)
  ]))
}
}

})